import React, { useState } from 'react';
import { MessageSquare, Phone, Mail, X } from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './FloatingContact.css';

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="floating-contact-container">
      <div className={`contact-options ${isOpen ? 'open' : ''}`}>
        <a href="https://wa.me/27663769466" target="_blank" rel="noreferrer" className="contact-fab-item whatsapp" title="WhatsApp Us">
          <FontAwesomeIcon icon={faWhatsapp} style={{ fontSize: '24px' }} />
        </a>
        <a href="mailto:info@singularitytech.co.za" className="contact-fab-item email" title="Email Us">
          <Mail size={24} />
        </a>
        <a href="tel:+27663769466" className="contact-fab-item phone" title="Call Us">
          <Phone size={24} />
        </a>
      </div>
      
      <button 
        className="contact-fab-main" 
        onClick={() => setIsOpen(!isOpen)}
        title="Contact Us"
      >
        {isOpen ? <X size={28} /> : <MessageSquare size={28} />}
      </button>
    </div>
  );
}